export function trueFn() {
  return true;
}
